const BatchIntervalEnum = {
  IMMEDIATELY: 1,
  EVERY_FIVE_MINUTES: 2,
  EVERY_HOUR: 3,
  DAILY: 4,
  WEEKLY: 5
}

export default BatchIntervalEnum



// WEBPACK FOOTER //
// ./src/enum/batchIntervalEnum.js